import { useEffect, useState } from 'react';

const useIsRowHover = (rowId: number | string) => {
	const [hovered, setHovered] = useState<boolean>(false);

	useEffect(() => {
		const RowEl = document.querySelector(`[class*=detailed-row-${rowId}]`);
		const config = { attributes: true };

		const _observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				if (mutation.attributeName === 'class') {
					setHovered(RowEl.classList.contains('hovered'));
				}
			});
		});

		_observer.observe(RowEl, config);

		return () => {
			_observer.disconnect();
		};
	}, [rowId]);

	return hovered;
};

export default useIsRowHover;
